import { StepAction } from 'Components/buttons/stepButton';
import CurrentStepActions from './constants';
import { IActionObject } from './types';

// action creators

// Sets current step based on id
export function setCurrentStep(
  currentStep: number,
  stepAction: StepAction
): IActionObject {
  return {
    type: CurrentStepActions.SET_CURRENT_STEP,
    data: { currentStep, stepAction },
  };
}

// Sets current step back to 0
export function resetCurrentStep(): IActionObject {
  return { type: CurrentStepActions.RESET_CURRENT_STEP };
}
